import React, { Component } from 'react';
import { Switch } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getVariableServer } from '../selectors/global.selector';
import { I18n } from 'react-redux-i18n';

class SwitchHideDisabledProduct extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.onChange = this.onChange.bind(this);
	}

	onChange(e) {
		const isSuite = this.props.isSwiftVersion;
		if (isSuite) {
			this.props.setMenuAllowHidden(e.target.checked ? '1' : '0');
		}
	}

	render() {
		const { isSwiftVersion, allow_hidden } = this.props;
		const isModeMaison = !!window.sessionStorage.getItem('master_mono_child');
		const value = isSwiftVersion ? allow_hidden : true;

		if (!isModeMaison) return '';

		const style = { color: 'white', textAlign: 'right', width: '100%' };

		return (
			<div style={style}>
				<Switch
					disabled={!isSwiftVersion}
					onClick={this.onChange}
					checked={value}
				/>{' '}
				{I18n.t('product.disaplay_disable_product')}
			</div>
		);
	}
}

const mapStateToProps = state => {
	const { entity, user } = state;
	const { variable } = entity;
	return {
		isSwiftVersion: user.isSwiftVersion,
		allow_hidden:
			getVariableServer(variable, 'menu_allow_hidden_p') == 1 ? true : false,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setMenuAllowHidden: value =>
			dispatch({ type: 'REQUEST_SET_MENU_ALLOW_HIDDEN', value }),
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(SwitchHideDisabledProduct);
